import styled from "styled-components";
import {HEADER_Z_INDEX} from "../../../../../header/header-consts";

export const VideoSlidesArenaRegulatoryDataBox = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    z-index: ${HEADER_Z_INDEX + 1};
`